require ('babel-polyfill');